/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
import React from 'react';
import './AboutSection.css';

const AboutSection = () => {
  return (
    <div className="about-me-container">
  <div className="about-me-logo">
    <img src={process.env.PUBLIC_URL + '/assets/logo-mastered-trax-logo.png'} alt="Mastered Trax Logo" className="logo-image" />
  </div>
  <div className="about-me-content">
    <h1>SOBRE NOSOTROS</h1>
    <p>
      Mastered Trax, es un sello discográfico independiente, 
      experto en la representación y desarrollo de artistas, poniendo a su disposición relaciones y experiencia para el crecimiento de cualquier proyecto musical, 
      buscando posicionarlos en grandes iconos a nivel internacional.Teniendo como objetivo llevar el hip hop a otro nivel, cruzando barreras y con amplia visión de extensión a distintos géneros musicales.
      Actualmente trabajando en proyectos de Hip - Hop, Regional Mexicano y R&B/ Urbano. Mastered Trax con años de trayectoria, fue fundado de manera oficial en el año 2014 por José Luis Maldonado “C-Kan”,
      José “Joe” Acevedo y Jesús “Homie” Castro, quienes en conjunto con el equipo que conforma esta gran familia, tienen la capacidad para llevar a cabo el éxito con cada uno de los artistas.
      En esta compañía estamos comprometidos a producir material de calidad y excelencia, 
      aplicando los valores que nos identifican, lealtad, constancia, integridad y perseverancia.
      En esta compañía estamos comprometidos a producir material de calidad y excelencia, 
      aplicando los valores que nos identifican, lealtad, constancia, integridad y perseverancia.
    </p>
  </div>
</div>

  );
};

export default AboutSection;